import { render, staticRenderFns } from "./VotesPending.vue?vue&type=template&id=cddb4206"
import script from "./VotesPending.vue?vue&type=script&lang=js"
export * from "./VotesPending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports